module.exports = __webpack_public_path__ + "img/thumb-riva-ananta.c1f505a9.png";